import * as Sentry from '@sentry/vue'
import { defineNuxtPlugin, useRouter, useRuntimeConfig } from '#imports'

export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter()
  const config = useRuntimeConfig()
  
  // Only initialize in production or staging environments
  const isDevelopment = process.env.NODE_ENV === 'development'
  
  Sentry.init({
    app: nuxtApp.vueApp,
    dsn: "https://2c572dbf9ddb82d36124c68d549fe55d@o4509930596270080.ingest.us.sentry.io/4509930989682688",
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    
    // Performance Monitoring
    tracesSampleRate: isDevelopment ? 1.0 : 0.1, // Capture 100% of transactions in dev, 10% in production
    
    // Session Replay
    replaysSessionSampleRate: 0.1, // Sample 10% of sessions
    replaysOnErrorSampleRate: 1.0, // Sample 100% of sessions with errors
    
    // Release tracking
    release: process.env.NUXT_PUBLIC_APP_VERSION || 'unknown',
    
    // Environment
    environment: isDevelopment ? 'development' : (config.public.apiUrl?.includes('stg') ? 'staging' : 'production'),
    
    // Send default PII data
    sendDefaultPii: true,
    
    // Additional options
    ignoreErrors: [
      // Ignore common browser extensions errors
      'ResizeObserver loop limit exceeded',
      'Non-Error promise rejection captured',
      // Add more patterns as needed
    ],
    
    beforeSend(event, hint) {
      // Filter out certain errors if needed
      if (isDevelopment) {
        console.log('Sentry Event:', event)
      }
      return event
    },
  })
  
  // Provide Sentry instance to the app
  return {
    provide: {
      sentry: Sentry
    }
  }
})